<script lang="ts" setup>
import { ref, onMounted } from 'vue'
import BsTextButtonDialog from '@/legacy/components/TextButtonDialog.vue'
import { DialogType } from '@/types/DialogLegacy'
import useOverlay from '@/legacy/ts/useOverlay'

const props = defineProps({
	modelValue: {
		type: Boolean,
		default: false,
	},
	type: {
		type: String,
		default: DialogType.Normal,
	},
	title: {
		type: String,
		default: '',
	},
	text: {
		type: String,
		default: '',
	},
	cancel: {
		type: Function,
	},
	cancelText: {
		type: String,
		default: 'cancel',
	},
	confirm: {
		type: Function,
	},
	confirmText: {
		type: String,
		default: 'confirm',
	},
	closeText: {
		type: String,
	},
	isAutoClose: {
		type: Boolean,
		default: true,
	},
	isHideButtonCancel: {
		type: Boolean,
		default: false,
	},
	isHideButtonClose: {
		type: Boolean,
		default: true,
	},
	isLockScroll: {
		type: Boolean,
		default: false,
	},
	isSmallSize: {
		type: Boolean,
		default: false,
	},
})

const emit = defineEmits(['onOverlayClick', 'update:modelValue', 'on-hide'])

const isLoading = ref(true)
const { isShow, freezeBodyScroll } = useOverlay(props, updateModelValue, onHide)

function onHide() {
	emit('on-hide')
}

function updateModelValue(value: boolean) {
	emit('update:modelValue', value)
}

function onOverlayClick(target: any) {
	emit('onOverlayClick', target)
	if (props.isAutoClose) isShow.value = false
}

onMounted(() => {
	if (props.isLockScroll) {
		freezeBodyScroll()
	}

	isLoading.value = false
})
</script>

<template>
	<transition name="bs-dialog-action-zoom-in-out">
		<div class="bs-dialog-action" v-show="isShow">
			<div
				:class="[
					'bs-dialog-action__overlay',
					{
						'bs-dialog-action__overlay__deep': type === DialogType.BottomSheet,
					},
				]"
				@click.capture="onOverlayClick"
			>
				<span
					v-if="!isHideButtonClose"
					class="bs-dialog-action__close"
					@click="isShow = false"
				>
					<i class="bs-dialog-action__close__icon"></i>
					<span class="bs-dialog-action__close__text">{{ closeText }}</span>
				</span>
			</div>
			<div
				id="dialogSurface"
				:class="[
					'bs-dialog-action__surface',
					`bs-dialog-action__${type}`,
					{ 'bs-dialog-action__surface__small': isSmallSize },
				]"
			>
				<slot name="content">
					<span v-if="title !== ''" class="bs-dialog-action__normal__title">
						{{ title }}
					</span>
					<span class="bs-dialog-action__normal__text" v-html="text"></span>
					<div class="bs-dialog-action__normal__action">
						<BsTextButtonDialog
							:text="cancelText"
							:action="cancel"
							v-if="!isHideButtonCancel"
						/>
						<BsTextButtonDialog :text="confirmText" :action="confirm" />
					</div>
				</slot>
			</div>
		</div>
	</transition>
</template>
